import { render, staticRenderFns } from "./downList.vue?vue&type=template&id=416a4924&scoped=true"
import script from "./downList.vue?vue&type=script&lang=js"
export * from "./downList.vue?vue&type=script&lang=js"
import style0 from "./downList.vue?vue&type=style&index=0&id=416a4924&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "416a4924",
  null
  
)

export default component.exports